import { AppError } from "@/lib/utils/errors";
import { businessService } from "@/modules/services/businessService";
import { metadataService } from "@/modules/services/metadataService";
import { useMetadataStore } from "@/modules/store/metadataStore";
import { useEffect } from "react";

export const useMetadata = () => {
  const {
    levels,
    degrees,
    languages,
    categories,
    industries,
    setLevels,
    setDegrees,
    setLanguages,
    setCategories,
    setIndustries,
  } = useMetadataStore();

  const fetchLevels = async () => {
    try {
      const resp = await metadataService.getLevels();
      if (resp) {
        setLevels(resp.levels || []);
      }
    } catch (err) {
      const appErr = new AppError(err);
      appErr.setAction("useMetadata");
      appErr.setApiAction("metadataService.getLevels");
      appErr.logError();
    }
  };

  const fetchDegrees = async () => {
    try {
      const resp = await metadataService.getDegrees();
      if (resp) {
        setDegrees(resp.degrees || []);
      }
    } catch (err) {
      const appErr = new AppError(err);
      appErr.setAction("useMetadata");
      appErr.setApiAction("metadataService.getDegrees");
      appErr.logError();
    }
  };

  const fetchLanguages = async () => {
    try {
      const resp = await metadataService.getLanguages();
      if (resp) {
        setLanguages(resp.languages || []);
      }
    } catch (err) {
      const appErr = new AppError(err);
      appErr.setAction("useMetadata");
      appErr.setApiAction("metadataService.getLanguages");
      appErr.logError();
    }
  };

  const fetchCategories = async () => {
    try {
      const resp = await metadataService.getCategories();
      if (resp) {
        setCategories(resp.categories || []);
      }
    } catch (err) {
      const appErr = new AppError(err);
      appErr.setAction("useMetadata");
      appErr.setApiAction("metadataService.getCategories");
      appErr.logError();
    }
  };

  const fetchIndustries = async () => {
    try {
      const resp = await businessService.getIndustries();
      if (resp) {
        setIndustries(resp.industry || []);
      }
    } catch (err) {
      const appErr = new AppError(err);
      appErr.setAction("useMetadata");
      appErr.setApiAction("businessService.getIndustries");
      appErr.logError();
    }
  };

  useEffect(() => {
    if (!levels || levels.length <= 0) {
      fetchLevels();
    }
    if (!degrees || degrees.length <= 0) {
      fetchDegrees();
    }
    if (!languages || languages.length <= 0) {
      fetchLanguages();
    }
    if (!categories || categories.length <= 0) {
      fetchCategories();
    }
    if (!industries || industries.length <= 0) {
      fetchIndustries();
    }
  }, []);

  return {
    levels,
    degrees,
    languages,
    categories,
    industries,
  };
};
